export default {
  filterCommonLoading: "加载中...",
  filterCommonNoData: "暂无数据",

  hiringLocation: "雇佣地点",
  dateRange: "时间区域",
  marketGalleries: "种类",
  marketGalleriesPlaceholder: "请输入种类",
  marketCategories: "分类",
  marketCategoriesPlaceholder: "请输入分类",
  newsLocations: "新闻位置",
  publishedDateRange: "发表时间区域",
  industryCategories: "行业分类",
  industryCategoriesPlaceholder: "请输入行业分类",
  industrySubCategories: "子行业",
  sequencePlaceholder: "请输入工作流程名称",
  pageviewGreaterThan: "页面浏览量",
  sessionGreaterThan: "会话数",
  advertisements: "广告",
  accountLocation: "账户地址",
  startDate: "开始时间",
  endDate: "结束时间",
  inputNumberMin: "最小",
  inputNumberMax: "最大",
  postingLocation: "发布地点",

  filterJob: "工作",
  filterJobPostingDateSubTitle: "发布时间段",
  filterJobPostingLocation: "发布地点",
  filterJobTitlesSubTitle: "职位名称",

  filterNews: "新闻",
  filterNewsPublishedDateSubTitle: "发布时间段",
  filterNewsCategories: "分类",

  filterEmployeeCustomRange: "自定义范围",

  filterAdvancedSearch: "高级搜索",
  allSearchResultsFor: '"{count}" 的所有搜索结果',
  filterAdvancedSearchTooltip: "按含义查找结果，而不仅仅是精确的单词。",

  filterSpecialties: "专长",
  filterSpecialtiesPlaceHolder: "请输入专长",

  filterIndustrySubCategories: "子行业",
  filterIndustrySubCategoriesPlaceHolder: "请输入子行业",

  filterAdPlaceholder: "请输入广告名称",

  filterEmployeesPlaceholder: "请选择员工数量",

  filterLocationExcludeText: "排除所选位置",
  filterLocationExcludeTooltip: "启用后，这些位置将从结果中过滤掉。",
  filterManagementPlaceholder: "请输入管理层级别",

  filterJobFunctionPlaceholder: "请输入职务功能",

  filterDepartmentPlaceholder: "请输入部门",

  filterPage: "页面",
  filterPerPage: "每页页数",

  filterCompanyPlaceHolder: "输入公司",
  filterCompanyCSVImport: "轻松导入您已有的公司列表",
  filterCompanyCSVText: "导入公司列表（CSV）",

  csvComponentTitle1: "上传 CSV",
  csvComponentTitle2: "审核上传内容",
  csvTipNeedHelp: "需要帮助吗？",
  detectFileNumber: "检测到 {count} 家公司",
  uploadLoading: "上传中...",
  uploadReplace: "替换",
  noCompaniesWereDetectedInYourFile:
    "文件中未检测到公司信息。请检查您的数据并重新上传。",
  fileContainsManyCompanies: "您的文件包含许多公司，将只使用前{count}个。",
  onlyReturnOneResultPerCompany: "每家公司仅返回 1 条结果",
  btnViewCompanyList: "查看公司列表",
  csvFileAnalysisFailed: "CSV 文件分析失败，请稍后再试",
  downloadFailed: "下载失败，请重试。",
  downloadSampleCsv: "下载 CSV 示例",
  firstHundredEntriesWillBeProcessed: "每个文件仅处理前{count}条记录。",
  detectingCompaniesInFile: "正在检测文件中的公司。。。",
  thisMayTakeAFewSeconds: "这可能需要几秒钟的时间。",

  filterSaveText: "保存搜索条件",
  filterClearAllText: "清除全部",

  filterRemoved: "过滤器已移除",
};
